import { render, staticRenderFns } from "./index.vue?vue&type=template&id=582ee074"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('582ee074')) {
      api.createRecord('582ee074', component.options)
    } else {
      api.reload('582ee074', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=582ee074", function () {
      api.rerender('582ee074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/pages/leads-report/index.vue"
export default component.exports